import React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";
import {
  warningCardHeader,
  successCardHeader,
  dangerCardHeader,
  infoCardHeader,
  primaryCardHeader,
  roseCardHeader,
  whiteColor,
  yellowCardHeader,
} from "./../../assets/jss/material-dashboard-react";

const colorStyles = {
  warning: warningCardHeader,
  success: successCardHeader,
  danger: dangerCardHeader,
  info: infoCardHeader,
  primary: primaryCardHeader,
  rose: roseCardHeader,
  yellow: yellowCardHeader,
};

const StyledCardHeader = styled(Box, {
  shouldForwardProp: (prop) =>
    !["color", "plain", "stats", "icon"].includes(prop),
})(({ color, plain, stats, icon }) => {
  const styles = {
    padding: "0.75rem 1.25rem",
    marginBottom: "0rem",
    borderBottom: "none",
    background: "transparent",
    zIndex: 3,
  };

  if (plain) {
    styles.marginLeft = "0px";
    styles.marginRight = "0px";
  }

  if (stats) {
    styles["& i, & .material-icons"] = {
      fontSize: "28px",
      lineHeight: "56px",
      width: "50px",
      height: "50px",
      textAlign: "end",
      overflow: "unset",
      marginBottom: "1px",
    };
  }

  if (icon) {
    styles["& svg"] = {
      width: "2.5rem",
      height: "2.5rem",
      textAlign: "center",
      lineHeight: "33px",
      margin: "12px 12px 0px",
    };
  }

  if (color && icon) {
    styles.background = "transparent";
    styles.boxShadow = "none";
  }

  if (color && !icon) {
    Object.assign(styles, {
      ...(colorStyles[color] || {}),
      borderRadius: "3px",
      marginTop: "-20px",
      padding: "15px",
    });
  }

  if (color) {
    styles.color = whiteColor;
  }

  return styles;
});

export default function CardHeader(props) {
  const { className, children, color, plain, stats, icon, ...rest } = props;

  return (
    <StyledCardHeader
      color={color}
      plain={plain}
      stats={stats}
      icon={icon}
      className={className}
      {...rest}
    >
      {children}
    </StyledCardHeader>
  );
}

CardHeader.propTypes = {
  className: PropTypes.string,
  color: PropTypes.oneOf([
    "warning",
    "success",
    "danger",
    "info",
    "primary",
    "rose",
    "yellow",
  ]),
  plain: PropTypes.bool,
  stats: PropTypes.bool,
  icon: PropTypes.bool,
  children: PropTypes.node,
};
